import { JSX } from "react";
import { appContext } from "../../../AppContext";
import { LogOutReason } from "../../../Common/Authentication";
import { IRouterProps, withRouting } from "@iconics/components";
import { IbssComponent } from "../../../Components/Core/BaseComponent/IbssComponent";

class LoginCallback extends IbssComponent<IProps, IState>
{
    public async componentDidMount(): Promise<void>
    {
        try
        {
            const user = appContext().localStorageProvider.getUserDetails();

            switch (user.providerType)
            {
                default:
                    window.setTimeout(() => this.props.navigate('/login/success'), 0);
            }
        }
        catch (error)
        {
            console.error(error);
            await appContext().authentication.logOut(LogOutReason.LoginFailed);
        }
    }

    public render(): JSX.Element
    {
        return (<></>);
    }
}

export default withRouting(LoginCallback);
export interface IProps extends IRouterProps { }
export interface IState { }
